import { apiFetch, parseApiResponse } from '../../utils/apiClient';

const request = async (path, options) => parseApiResponse(await apiFetch(path, options));

export const stockApi = {
  getSummary: () => request('/api/stock/summary'),
  listItems: () => request('/api/stock/items'),
  getItem: (id) => request(`/api/stock/items/${id}`),
  createItem: (payload) => request('/api/stock/items', { method: 'POST', body: JSON.stringify(payload) }),
  updateItem: (id, payload) => request(`/api/stock/items/${id}`, { method: 'PUT', body: JSON.stringify(payload) }),
  deleteItem: async (id) => {
    const response = await apiFetch(`/api/stock/items/${id}`, { method: 'DELETE' });
    if (!response.ok) return parseApiResponse(response);
    return true;
  },
  listMovements: () => request('/api/stock/movements'),
  createMovement: (payload) => request('/api/stock/movements', { method: 'POST', body: JSON.stringify(payload) }),
  listNeeds: ({ includeArchived = false } = {}) => request(`/api/stock/needs${includeArchived ? '?includeArchived=1' : ''}`),
  createNeed: (payload) => request('/api/stock/needs', { method: 'POST', body: JSON.stringify(payload) }),
  updateNeedStatus: (id, status) => request(`/api/stock/needs/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status }) }),
  reserveNeed: (id) => request(`/api/stock/needs/${id}/reserve`, { method: 'POST', body: JSON.stringify({}) }),
  receiveNeed: (id) => request(`/api/stock/needs/${id}/receive`, { method: 'POST', body: JSON.stringify({}) }),
  archiveNeed: (id) => request(`/api/stock/needs/${id}/archive`, { method: 'POST', body: JSON.stringify({}) }),
  restoreNeed: (id) => request(`/api/stock/needs/${id}/restore`, { method: 'POST', body: JSON.stringify({}) }),
  linkNeedToStockItem: (id, stockItemId) => request(`/api/stock/needs/${id}/link-stock-item`, { method: 'POST', body: JSON.stringify({ stockItemId }) }),
  createStockItemFromNeed: (id, payload) => request(`/api/stock/needs/${id}/create-stock-item`, { method: 'POST', body: JSON.stringify(payload) }),
};
